module.exports = __webpack_public_path__ + "static/media/HrfhVNmTG9.5cfe0805.png";